import React, { useState } from 'react';
import './Alert.css'; // Подключим стили

const Alert = ({ message, type, onClose }) => {
  return (
    <div className={`alert ${type}`} role="alert">
      <span>{message}</span>
      <button onClick={onClose} className="close-btn">X</button>
    </div>
  );
};

export default Alert;
